<p-toast></p-toast>
<p-card>
    <!-- <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div> -->

    <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-6 p-lg-4">
            <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>
            <p-table #dt [value]="lista" [rows]="25" [paginator]="true" [scrollable]="true" scrollHeight="680px"
                [globalFilterFields]="['nome','endereco_cobranca','numero_cobranca','bairro_cobranca','visita']"
                [(selection)]="selecionados" [rowHover]="true" dataKey="cod_cliente" styleClass="p-datatable-customers"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value,'contains')"
                                placeholder="Pesquisar Cliente..." />
                        </span>
                    </div>
                    <br>
                    <div class="p-col-12 p-md-12 p-lg-12">
                        <label for="visita">Visita</label>
                        <p-dropdown class="p-inputtext-sm" [options]="visitas" [(ngModel)]="selecionarVisita"
                            [showClear]="true" optionLabel="descricao" placeholder="Selecione a Visita"></p-dropdown>
                    </div>
                    <div class="p-col-12 p-md-12 p-lg-12"></div>
                    <br>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-col-12 p-md-6 p-lg-6">
                            <label class="labelBlackBold">Data Inicial:</label>
                            <p-calendar [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                                inputId="icon">
                            </p-calendar>
                        </div>
                        <div class="p-col-12 p-md-6 p-lg-6">
                            <label class="labelBlackBold">Data Final:</label>
                            <p-calendar [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true" inputId="icon">
                            </p-calendar>
                        </div>

                    </div>
                    <br>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-col-12 p-md-6 p-lg-12">
                            <button pButton pRipple type="button" label="Pesquisar" class="p-button-raised"
                                (click)="pesquisar()"></button>
                        </div>
                    </div>
                    <br>
                    <div class="p-col-12 p-md-6 p-lg-12">
                        <div class="p-col-12 p-md-6 p-lg-12">
                            Registros: {{lista? lista.length: 0}}
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem;">
                        </th>
                        <th pSortableColumn="nome">Cliente
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dados>
                    <tr style="cursor:pointer;" (click)="setarPosicao(gmap.getMap(), dados)">
                        <td style="width: 3rem;">
                            <div class="box-quadrado" [style.background-color]="verificarPinMapa(dados)">
                            </div>
                        </td>
                        <td>
                            <b>{{dados.nome}}</b>
                            <br />
                            {{dados.endereco_cobranca}} - {{dados.bairro_cobranca}} - {{dados.numero_cobranca}} - {{dados.cidade_cobranca}} - {{dados.estado_cobranca}}
                            <br />
                            <b>{{dados.visita}}</b>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="2" style="text-align: center;font-size: large;">Não há registros.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="p-col-12 p-md-6 p-lg-8">
            <p-gmap #gmap [style]="{'width':'100%','height':'820px', 'margin-bottom': '1em'}" [options]="options"
                [overlays]="overlays" (onOverlayClick)="handleOverlayClick($event)"></p-gmap>
        </div>
    </div>
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
</p-card>